function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import Popup from '../popup';
import { getMountContainer } from '../utils/dom';
import ActivityIndicator from '../activity-indicator';

var Loading =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Loading, _PureComponent);

  function Loading() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Loading);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Loading)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.timer = void 0;
    _this.state = {
      visible: _this.props.visible
    };

    _this.afterClose = function () {
      var afterClose = _this.props.afterClose;

      if (Loading.zarmLoading) {
        Loading.loadingContainer.removeChild(Loading.zarmLoading);
        Loading.zarmLoading = null;
      }

      if (typeof afterClose === 'function') {
        afterClose();
      }
    };

    _this._hide = function () {
      _this.setState({
        visible: false
      });
    };

    return _this;
  }

  _createClass(Loading, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      Loading.hideHelper = this._hide;
      this.autoClose();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var visible = this.props.visible;

      if (prevProps.visible !== visible) {
        if (visible === true) {
          // eslint-disable-next-line
          this.setState({
            visible: true
          });
          this.autoClose();
        } else {
          this._hide();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "autoClose",
    value: function autoClose() {
      var _this2 = this;

      var stayTime = this.props.stayTime;

      if (stayTime > 0) {
        this.timer = setTimeout(function () {
          _this2._hide();

          clearTimeout(_this2.timer);
        }, stayTime);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          content = _this$props.content,
          stayTime = _this$props.stayTime,
          className = _this$props.className,
          others = _objectWithoutProperties(_this$props, ["prefixCls", "content", "stayTime", "className"]);

      var visible = this.state.visible;
      return React.createElement(Popup, _extends({
        direction: "center",
        maskType: "transparent",
        width: "70%"
      }, others, {
        visible: visible,
        afterClose: this.afterClose
      }), React.createElement("div", {
        className: prefixCls
      }, React.createElement("div", {
        className: "".concat(prefixCls, "__container")
      }, content || React.createElement(ActivityIndicator, {
        type: "spinner",
        size: "lg"
      }))));
    }
  }]);

  return Loading;
}(PureComponent);

Loading.defaultProps = {
  prefixCls: 'za-loading',
  mask: true
};
Loading.zarmLoading = void 0;
Loading.loadingContainer = void 0;
Loading.hideHelper = void 0;

Loading.show = function (content) {
  Loading.unmountNode();

  if (!Loading.zarmLoading) {
    Loading.zarmLoading = document.createElement('div');
    Loading.zarmLoading.classList.add('za-loading-container');

    if (content && content.className) {
      Loading.zarmLoading.classList.add(content.className);
    }

    Loading.loadingContainer = content ? getMountContainer(content.mountContainer) : getMountContainer();
    Loading.loadingContainer.appendChild(Loading.zarmLoading);
  }

  if (Loading.zarmLoading) {
    var props = _objectSpread({}, Loading.defaultProps, {}, content, {}, {
      visible: true,
      mountContainer: Loading.zarmLoading
    });

    ReactDOM.render(React.createElement(Loading, props), Loading.zarmLoading);
  }
};

Loading.hide = function () {
  if (Loading.zarmLoading) {
    ReactDOM.render(React.createElement(Loading, {
      visible: false
    }), Loading.zarmLoading);
  }
};

Loading.unmountNode = function () {
  var zarmLoading = Loading.zarmLoading;

  if (zarmLoading) {
    ReactDOM.render(React.createElement(React.Fragment, null), zarmLoading);
    Loading.loadingContainer.removeChild(zarmLoading);
    Loading.zarmLoading = null;
  }
};

export { Loading as default };